import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { G } from './Reveal';

const roadmap = {
  current: {
    label: 'Current',
    title: 'Closed-Beta MVP',
    dot: G,
    items: ['Structured discovery', 'AI-assisted scoping concepts', 'Capability decomposition', 'Professional workflow', 'Team / project structure', 'Milestones and governance', 'Demo environment', 'Controlled founder-led validation'],
  },
  next: {
    label: 'Next',
    title: 'Product Hardening & Controlled Delivery',
    dot: '#e5e5e5',
    items: ['Specialist full-stack engineering', 'Code and release review', 'Testing', 'Security and recovery controls', 'Improved workflow automation', 'Stronger professional evidence structures', 'Project-control records', 'Evaluation and monitoring', 'Controlled live-project use', 'Privacy and data-governance refinement'],
  },
  future: {
    label: 'Future',
    title: 'Exploration',
    dot: '#525252',
    items: ['Deeper project intelligence', 'Improved capability matching', 'Cumulative project-learning models', 'Organisation-level project memory', 'Integrations with business tools', 'Broader professional collaboration', 'Recurring workspace functionality', 'Advanced governance and assurance', 'International project delivery', 'Carefully structured payment-related functionality through appropriate providers'],
  },
};

const keys = ['current', 'next', 'future'];

const RoadmapItem = ({ text, accent }) => (
  <div className="flex items-start gap-3 py-1">
    <CheckCircle2 className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: accent }} />
    <span className="text-sm text-neutral-300 leading-snug">{text}</span>
  </div>
);

export const RoadmapTabs = () => {
  const [tab, setTab] = useState('current');
  const label = roadmap[tab].label;
  const title = roadmap[tab].title;
  const dot = roadmap[tab].dot;
  const items = roadmap[tab].items;
  const accent = tab === 'current' ? G : '#737373';

  return (
    <div>
      <div className="inline-flex p-1 rounded-full border border-white/10 bg-[#111]">
        {keys.map((k) => {
          const on = tab === k;
          return (
            <button
              key={k}
              onClick={() => setTab(k)}
              className="relative px-5 sm:px-7 py-2.5 rounded-full font-display font-bold text-sm uppercase tracking-wide transition-colors"
              style={{ background: on ? G : 'transparent', color: on ? '#0a0a0a' : '#a3a3a3' }}
              data-testid={`roadmap-tab-${k}`}
            >
              {roadmap[k].label}
            </button>
          );
        })}
      </div>

      <div key={tab} className="mt-8 rounded-3xl border border-white/10 bg-[#111] p-6 sm:p-9 cb-reveal cb-in">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: dot }} />
          <span className="text-xs uppercase tracking-[0.2em] text-neutral-500 font-semibold">{label}</span>
          <h3 className="font-display font-extrabold text-white text-xl sm:text-2xl ml-1">{title}</h3>
        </div>
        <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
          {items.map((x) => (
            <RoadmapItem key={x} text={x} accent={accent} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoadmapTabs;
